export default __webpack_public_path__ + "static/bridge-xs-a68cc9084f7114a669e539b9bb5ff21a.webp";